import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { RegistrationError } from './errors'
import { RegistrationResponse, RegistrationUserMetadata } from './types'

export type RegistrationState =
  | {
      name: 'initial'
    }
  | { name: 'signup_loading'; continueCount: number }
  | { name: 'signup_complete'; response: RegistrationResponse<RegistrationUserMetadata> }
  | { name: 'signup_error'; error: RegistrationError }
  | { name: 'login_loading' }
  | { name: 'login_error' }

export const [registrationState$, setRegistrationState] = createSignal<RegistrationState>()

export const [useRegistrationState] = bind(registrationState$, { name: 'initial' })

export const formDisabledStates: ReadonlyArray<RegistrationState['name']> = [
  'signup_loading',
  'signup_complete',
  'login_loading',
  'login_error',
]

export const formProcessingStates: ReadonlyArray<RegistrationState['name']> = [
  'signup_loading',
  'login_loading',
]
